export default "__VITE_ASSET__C3kqhdy7__"